import StatusContainer from './status_container';

const Status = StatusContainer;

export default Status;
